var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44.509,
    y: 1.56756,
    width: 43.2647,
    height: 54.7602,
    fill: "#FFDF0A",
    stroke: "black",
    strokeWidth: 3.13512
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0832,
    y: 6.9201,
    width: 43.2647,
    height: 54.7602,
    fill: "#FFDF0A",
    stroke: "black",
    strokeWidth: 3.13512
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.9347,
    y: 13.1901,
    width: 43.2647,
    height: 54.7602,
    fill: "#FFDF0A",
    stroke: "black",
    strokeWidth: 3.13512
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1574,
    y: 19.8786,
    width: 43.2647,
    height: 54.7602,
    fill: "#FFDF0A",
    stroke: "black",
    strokeWidth: 3.13512
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.0051,
    y: 26.1491,
    width: 43.2647,
    height: 54.7602,
    fill: "#FFDF0A",
    stroke: "black",
    strokeWidth: 3.13512
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2.22772,
    y: 32.8371,
    width: 43.2647,
    height: 54.7602,
    fill: "#FFDF0A",
    stroke: "black",
    strokeWidth: 3.13512
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2601 56.1999C19.2483 56.1999 20.8601 54.5882 20.8601 52.6C20.8601 50.6118 19.2483 49 17.2601 49C15.2719 49 13.6602 50.6118 13.6602 52.6C13.6602 54.5882 15.2719 56.1999 17.2601 56.1999Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4566 62C28.5662 62 32.8636 65.322 34.2237 69.8557C34.2619 69.9911 34.2678 70.1335 34.241 70.2716C34.2142 70.4097 34.1553 70.5396 34.0693 70.6508C33.9832 70.7621 33.8722 70.8516 33.7453 70.9122C33.6183 70.9728 33.479 71.0028 33.3383 70.9998H13.5737C13.4335 71.0019 13.2948 70.9712 13.1686 70.9102C13.0424 70.8493 12.9321 70.7596 12.8467 70.6485C12.7612 70.5374 12.7029 70.4078 12.6764 70.2702C12.6499 70.1325 12.6559 69.9906 12.6939 69.8557C14.0428 65.322 18.3413 62 23.4566 62Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2601 56.1999C32.2483 56.1999 33.8601 54.5882 33.8601 52.6C33.8601 50.6118 32.2483 49 30.2601 49C28.2719 49 26.6602 50.6118 26.6602 52.6C26.6602 54.5882 28.2719 56.1999 30.2601 56.1999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.e98df4f6ec88556636486bf9802a3f42.svg";
export { ForwardRef as ReactComponent };